import React from "react";
import cn from "classnames";

import { type WizardNewProps } from "./wizardNewPropTypes";
import WizardHeader from "components/wizard/WizardHeader";
import WizardSubHeader from "./WizardSubHeader";
import WizardFooter from "./WizardFooter";
import WizardStep from "./WizardStep";
import "./wizard.scss";
import { useWizard } from "../../hooks/useWizard";

export const WizardNew = (props: WizardNewProps) => {
  const {
    closeHandler,
    onStepSelected,
    onNext,
    onPrev,
    availableStepIndexes,
    activeStep,
    setActiveIndex,
    activeIndex,
    filteredChildren,
    onFinish,
  } = useWizard(props);

  return (
    <div id={props.id} className={cn("main-content wizard", `active-step-${activeIndex}`, props.className)}>
      <WizardHeader
        title={props.title}
        titleForGA={props.titleForGA}
        publishedStatus={props.publishedStatus || ""}
        onClose={closeHandler}
        changeActiveIndex={setActiveIndex}
        renderCustomHeader={props.renderCustomHeader}
      />
      <WizardSubHeader
        progressSavedDate={props.progressSavedDate}
        isSaveInProgress={props.isSaveInProgress}
        children={filteredChildren}
        activeIndex={activeIndex}
        onStepSelected={onStepSelected}
        availableStepIndexes={availableStepIndexes}
      />
      <WizardStep steps={filteredChildren} activeStepIndex={activeIndex} />
      <WizardFooter
        isNavigationLocked={activeStep.props.isLocked}
        activeIndex={activeIndex}
        stepsCount={filteredChildren.length}
        onNext={onNext}
        onPrev={onPrev}
        onFinish={onFinish}
        finishButtonLabel={props.finishButtonLabel}
        isFinishButtonDisabled={props.isFinishButtonDisabled}
        renderCustomFinishButton={props.renderCustomFinishButton}
        nextButtonLabel={activeStep.props.nextButtonLabel}
        isPreviousDisabled={props.isPreviousDisabled}
        finishTooltipMessage={props.finishTooltipMessage}
      />
    </div>
  );
};

export default WizardNew;
